import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { Category } from '@novaheal/types';
import { axios } from 'utils/axios';
import { CONTENTFUL_IS_PREVIEW } from 'config/env';

export const getCategoryById = async (id: string): Promise<Category | null> => {
  const { data: category } = await axios.get<Category | null>(
    `/gql/category/${id}?preview=${CONTENTFUL_IS_PREVIEW}`
  );

  return category;
};

export const useCategory = (id: string | undefined): UseQueryResult<Category | null, unknown> => {
  return useQuery({
    queryKey: [`category-${id}`],
    queryFn: () => getCategoryById(id as string),
  });
};
